import { NavigateExternalInlineIcon } from "@fluentui/react-icons-mdl2";
import { Link } from "@fluentui/react/lib/Link";
import { TooltipHost, TooltipOverflowMode } from "@fluentui/react/lib/Tooltip";

import { getName } from "Utils/Item";
import { isNotNullOrWhiteSpace } from "Utils/String";
import { WithTranslator } from "../Translator";
import { ITargetLinkProps } from "./ITargetLinkProps";
import { useTargetLinkStyles } from "./UseTargetLinkStyles";

export const TargetLink = WithTranslator((props: ITargetLinkProps): JSX.Element => {
  const { item, translator } = props;
  const { "@targetUrl": targetUrl } = item;
  const name = getName(item);
  const isExported = isNotNullOrWhiteSpace(targetUrl);
  const styles = useTargetLinkStyles();

  if (!isExported) {
    return (
      <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={name}>
        {name}
      </TooltipHost>
    );
  }

  return (
    <TooltipHost
      content={translator.get(`tooltip.openexternal`, `Opens the link in an external window.`)}
      overflowMode={TooltipOverflowMode.Parent}
    >
      <Link href={targetUrl} target="_blank" className={styles.link}>
        {name}
        <NavigateExternalInlineIcon className={styles.icon} />
      </Link>
    </TooltipHost>
  );
});
